<template>
    <div class="text-Upladerimage" style="padding: 10px;padding-bottom: 50px;">

        <div>

            <Form :label-width="60">

                <van-grid :column-num="3">
                    <van-grid-item icon="photo-o" text="合格证" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList1" name="1" :after-read="afterRead">
                                <div>合格证</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="登记证1" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList2" name="2" :after-read="afterRead">
                            <div>登记证1</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="登记证2" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList3" name="3" :after-read="afterRead">
                            <div>登记证2</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="行驶证" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList4" name="4" :after-read="afterRead">
                            <div>行驶证</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="行驶证副页" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList9" name="9" :after-read="afterRead">
                            <div>行驶证副页</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="车身照" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList5" name="5" :after-read="afterRead">
                            <div>车身照</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="货运转网合同" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList6" name="6" :after-read="afterRead">
                            <div>货运转网合同</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="货运转网授权书" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList7" name="7" :after-read="afterRead">
                            <div>货运转网授权书</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="身份识别证件" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList8" name="8" :after-read="afterRead">
                            <div>身份识别证件</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="身份识别证件背面" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList11" name="11" :after-read="afterRead">
                            <div>身份识别证件背面</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="交通局转网授权书" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList10" name="10" :after-read="afterRead">
                            <div>交通局转网授权书</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="道路运输许可证" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList12" name="12" :after-read="afterRead">
                            <div>道路运输许可证</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="营业执照" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList13" name="13" :after-read="afterRead">
                            <div>营业执照</div>
                        </van-uploader>
                    </van-grid-item>
                    <van-grid-item icon="photo-o" text="安装证明" style="width: 100px;height: 110px;">
                        <van-uploader :deletable="false" v-model="fileList14" name="14" :after-read="afterRead">
                            <div>安装证明</div>
                        </van-uploader>
                    </van-grid-item>
                </van-grid>

            </Form>

        </div>
        <div v-if="show" style="position: absolute;left:50%;top:50%;z-index: 9999">
            <van-loading color="#1989fa" type="spinner" size="60px"/>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import axios from 'axios'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        Uploader,Grid, GridItem
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem).use(Grid).use(GridItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast).use(Uploader);

    export default {
        name: "uploadvehiclematerialimage",
        props: {
            value: {
                type: Boolean,
                default: false
            },
            initValue: null
        },
        data() {
            return {
                fileList1: [],
                fileList2: [],
                fileList3: [],
                fileList4: [],
                fileList5: [],
                fileList6: [],
                fileList7: [],
                fileList8: [],
                fileList9: [],
                fileList10: [],
                fileList11: [],
                fileList12: [],
                fileList13: [],
                fileList14: [],
                postParams: {
                    upload_token: null,
                    picKey: null,
                },

                uploadFile: null,
                loadingStatus: false,

                addPictureRecord: {
                    picKey: null,
                    srcHeight: null,
                    srcWidth: null,
                    picType: 0
                },

                installOrder: null,

                show:false,
            }
        },
        methods: {
            afterRead(file,e) {
                // Toast('开始')
                this.show=true
                console.log(e)
                this.addPictureRecord.picType=e.name
                console.log(this.addPictureRecord.picType)
                //获取七牛上传凭证
                store.dispatch('PictureServ_GetQiniuUploadToken', {
                    params: {
                        head: 'INSTALLORDER'
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.postParams.upload_token = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                    this.postParams.picKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                    this.uploadFile = file.file;
                    this.upload()
                })
                    .catch((err) => {
                        console.log(err)
                        this.errorlog('七牛错误'+err)
                    })
            },
            upload() {
                console.log('开始上传')
                let param = new FormData(); //创建form对象
                param.append('chunk', '0');//断点传输
                param.append('chunks', '1');
                param.append('token', this.postParams.upload_token)
                param.append('key', this.postParams.picKey);
                param.append('file', this.uploadFile, this.uploadFile.name)
                console.log(this.uploadFile)
                console.log(this.uploadFile.name)

                let config = {
                    // headers:{'X-Requested-with':'XMLHttpRequest'},
                    // headers:{'Content-Type':'application/json'},
                    headers: {'Content-Type': 'multipart/form-data'},
                    // headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}  // 这里是跨域的写法
                    withCredentials: false
                };
                this.loadingStatus = true;

                // console.log(this.postParams.picKey)
                // console.log(this.addPictureRecord.picType)


                    axios.post('https://upload-z2.qiniup.com', param, config)
                        .then(response => {
                            console.log(response);
                            console.log(response.data);
                            // this.addPictureRecord.picKey = this.postParams.picKey

                            // console.log(this.addPictureRecord)

                            if (this.installOrder.businessType != 3) {
                                //  未完成的订单
                                //安装订单更换图片
                                store.dispatch('InstallOrderServ_ChangePicture', {
                                    params: {
                                        id: this._initValue,
                                        picKey: this.postParams.picKey,
                                        picType: this.addPictureRecord.picType,//图片类型数字
                                        srcWidth: this.addPictureRecord.srcWidth,
                                        srcHeight: this.addPictureRecord.srcHeight
                                    },
                                    urlparams: null
                                }).then((res) => {
                                    console.log(res)
                                    this.loadingStatus = false
                                    Toast.success('添加图片成功')
                                    this.uploadFile = null
                                    // this.reload()
                                    this.loadPhotoRecords()
                                }).catch(err => {
                                    this.loadingStatus = false
                                    Toast('添加图片失败' + err)
                                });
                            }else {
                                store.dispatch('VehicleInfoServ_ChangePicture', {
                                    params: {
                                        id: this.installOrder.vehicleInfoId,
                                        picKey: this.postParams.picKey,
                                        picType: this.addPictureRecord.picType,
                                        srcWidth: this.addPictureRecord.srcWidth,
                                        srcHeight: this.addPictureRecord.srcHeight
                                    },
                                    urlparams: null
                                }).then(() => {
                                    this.loadingStatus = false
                                    this.$Message.success('添加图片成功')
                                    this.uploadFile = null
                                    this.loadPhotoRecords()
                                }).catch(err => {
                                    this.loadingStatus = false
                                    this.$Message.error(err)
                                })
                            }
                        }).catch(err1 => {
                        Toast(err1)
                        this.loadingStatus = false
                    })
            },
            loadPhotoRecords() {
                store.dispatch('InstallOrderServ_GetDetail', {
                    params: {id: this._initValue},
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    // this.fileList.push({
                    //     url:'https://pic.jianchengjt.com/' +  + '?imageView2.jpg'
                    // })


                    let installOrder = store.getters.get_InstallOrder_GetDetailResult
                    this.installOrder = installOrder
                    if (this.installOrder.tempVehicleInfo!=null){

                    let vehicleInfo = this.installOrder.tempVehicleInfo
                    console.log(this.installOrder)
                    console.log(vehicleInfo)
                    this.fileList1 = []
                    this.fileList2 = []
                    this.fileList3 = []
                    this.fileList4 = []
                    this.fileList5 = []
                    this.fileList6 = []
                    this.fileList7 = []
                    this.fileList8 = []
                    this.fileList9 = []
                    this.fileList10 = []
                    this.fileList11 = []
                    this.fileList12 = []
                    this.fileList13 = []
                    this.fileList14 = []
                    if (vehicleInfo.vehicleBodyPicture) {//车身照：5
                        this.fileList5.push({
                            id:vehicleInfo.vehicleBodyPictureId,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.vehicleBodyPicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.vehicleSrcLicensePicture2) {//登记证1：2
                        this.fileList2.push({
                            id:vehicleInfo.vehicleSrcLicensePicture2Id,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.vehicleSrcLicensePicture2.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.vehicleSrcLicensePicture1) {//登记证2：3
                        this.fileList3.push({
                            id:vehicleInfo.vehicleSrcLicensePicture1Id,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.vehicleSrcLicensePicture1.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.certificatePicture) {//合格证：1
                        this.fileList1.push({
                            id:vehicleInfo.certificatePictureId,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.certificatePicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.vehicleLicensePicture) {//行驶证：4
                        this.fileList4.push({
                            id:vehicleInfo.vehicleLicensePictureId,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.vehicleLicensePicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.qghyptChangeContractPicture) {//合同：6
                        this.fileList6.push({
                            id:vehicleInfo.qghyptChangeContractPictureId,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.qghyptChangeContractPicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.qghyptChangeAuthorizationPicture) {//授权书：7
                        this.fileList7.push({
                            id:vehicleInfo.qghyptChangeAuthorizationPictureId,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.qghyptChangeAuthorizationPicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.idFilePicture) {//身份证：8
                        this.fileList8.push({
                            id:vehicleInfo.idFilePictureId,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.idFilePicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.vehicleLicenseFlapPicture) {//行驶证副页：9
                        this.fileList9.push({
                            id:vehicleInfo.vehicleLicenseFlapPictureId,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.vehicleLicenseFlapPicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.jtjChangeAuthorizationPicture) {
                        this.fileList10.push({
                            id:vehicleInfo.vehicleLicenseFlapPictureId,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.jtjChangeAuthorizationPicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.idFileBackPicture) {
                        this.fileList11.push({
                            id:vehicleInfo.vehicleLicenseFlapPictureId,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.idFileBackPicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.roadTransportationPermitCardPicture) {
                        this.fileList12.push({
                            id:vehicleInfo.vehicleLicenseFlapPictureId,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.roadTransportationPermitCardPicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.businessLicensePicture) {
                        this.fileList13.push({
                            id:vehicleInfo.vehicleLicenseFlapPictureId,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.businessLicensePicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    if (vehicleInfo.installationCertificatePicture) {
                        this.fileList14.push({
                            id:vehicleInfo.vehicleLicenseFlapPictureId,
                            url: 'https://pic.jianchengjt.com/' + vehicleInfo.installationCertificatePicture.picKey + '?imageView2',
                            isImage: true
                        })
                    }
                    } else {
                        store.dispatch('VehicleInfoServ_GetDetail', {
                            params: {id: installOrder.vehicleInfoId},
                            urlparams: null
                        }).then((res) => {
                           let vehicleInfo = store.getters.get_VehicleInfo_GetDetailResult
                            this.fileList1 = []
                            this.fileList2 = []
                            this.fileList3 = []
                            this.fileList4 = []
                            this.fileList5 = []
                            this.fileList6 = []
                            this.fileList7 = []
                            this.fileList8 = []
                            this.fileList9 = []
                            this.fileList10 = []
                            this.fileList11 = []
                            this.fileList12 = []
                            this.fileList13 = []
                            this.fileList14 = []
                            if (vehicleInfo.vehicleBodyPicture) {//车身照：5
                                this.fileList5.push({
                                    id:vehicleInfo.vehicleBodyPictureId,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.vehicleBodyPicture.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.vehicleSrcLicensePicture2) {//登记证1：2
                                this.fileList2.push({
                                    id:vehicleInfo.vehicleSrcLicensePicture2Id,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.vehicleSrcLicensePicture2.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.vehicleSrcLicensePicture1) {//登记证2：3
                                this.fileList3.push({
                                    id:vehicleInfo.vehicleSrcLicensePicture1Id,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.vehicleSrcLicensePicture1.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.certificatePicture) {//合格证：1
                                this.fileList1.push({
                                    id:vehicleInfo.certificatePictureId,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.certificatePicture.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.vehicleLicensePicture) {//行驶证：4
                                this.fileList4.push({
                                    id:vehicleInfo.vehicleLicensePictureId,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.vehicleLicensePicture.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.qghyptChangeContractPicture) {//合同：6
                                this.fileList6.push({
                                    id:vehicleInfo.qghyptChangeContractPictureId,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.qghyptChangeContractPicture.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.qghyptChangeAuthorizationPicture) {//授权书：7
                                this.fileList7.push({
                                    id:vehicleInfo.qghyptChangeAuthorizationPictureId,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.qghyptChangeAuthorizationPicture.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.idFilePicture) {//身份证：8
                                this.fileList8.push({
                                    id:vehicleInfo.idFilePictureId,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.idFilePicture.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.vehicleLicenseFlapPicture) {//行驶证副页：9
                                this.fileList9.push({
                                    id:vehicleInfo.vehicleLicenseFlapPictureId,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.vehicleLicenseFlapPicture.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.jtjChangeAuthorizationPicture) {
                                this.fileList10.push({
                                    id:vehicleInfo.vehicleLicenseFlapPictureId,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.jtjChangeAuthorizationPicture.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.idFileBackPicture) {
                                this.fileList11.push({
                                    id:vehicleInfo.vehicleLicenseFlapPictureId,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.idFileBackPicture.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.roadTransportationPermitCardPicture) {
                                this.fileList12.push({
                                    id:vehicleInfo.vehicleLicenseFlapPictureId,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.roadTransportationPermitCardPicture.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.businessLicensePicture) {
                                this.fileList13.push({
                                    id:vehicleInfo.vehicleLicenseFlapPictureId,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.businessLicensePicture.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                            if (vehicleInfo.installationCertificatePicture) {
                                this.fileList14.push({
                                    id:vehicleInfo.vehicleLicenseFlapPictureId,
                                    url: 'https://pic.jianchengjt.com/' + vehicleInfo.installationCertificatePicture.picKey + '?imageView2',
                                    isImage: true
                                })
                            }
                        }).catch(err=>{
                            console.log(err)
                        })
                    }
                    this.show=false
                }).catch((err) => {
                    console.log(err)
                })
            },
            errorlog(content){
                store.dispatch('WebAdminErrorLogServ_AddObj',{
                    params:{
                        code:999,
                        mes:content,
                    },
                    urlparams:null
                }).then((res)=>{
                    console.log(res)
                }).catch((err)=>{
                    console.log(err)
                })
            },
        },
        computed: {
            _value: {
                get () {
                    return this.value
                },
                set (val) {
                    this.$emit('input', val)
                    this.$emit('change', val)
                }
            },
            _initValue: {
                get () {
                    return this.initValue
                },
                set (val) {
                    // this.$emit('input', val);
                    // this.$emit('change', val);
                }
            }
        },
        mounted() {
            this.loadPhotoRecords()
        }
    }
</script>

<style scoped>
    .text-Upladerimage {
        width: 100%;
        height: 100%;
    }
</style>
